module.exports = __webpack_public_path__ + "static/media/ss-vocabulary-list.1bd22f3e.png";